export const LOAD_INTERNAL_MARKETERS = 'LOAD_INTERNAL_MARKETERS';
export type LOAD_INTERNAL_MARKETERS = typeof LOAD_INTERNAL_MARKETERS;

export interface LoadInternalMarketers {
    type: LOAD_INTERNAL_MARKETERS;
}

export function loadInternalMarketersAction(): LoadInternalMarketers {
    return {
        type: LOAD_INTERNAL_MARKETERS
    };
}
